import { Route } from "react-router-dom";

import {
  GENERATE_ACCOUNT_REPORT,
  GENERATE_CLIENT_REPORT,
  GENERATE_CRM_REPORT,
  GENERATE_DAILY_REPORT,
  GENERATE_EMPLOYEE_REPORT,
  GENERATE_EXPENSE_REPORT,
  GENERATE_MATERIAL_REPORT,
  GENERATE_PROJECT_REPORT,
  GENERATE_PURCHASE_REPORT,
  GENERATE_SUBCONTRACTOR_REPORT,
  GENERATE_TOOL_REPORT,
  GENERATE_USER_REPORT,
  GENERATE_VENDOR_REPORT,
  GENERATE_WORKER_REPORT,
} from "src/constants";
import { REPORT_ROUTES } from "src/pages/report/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AccountReport } from "./AccountReport.page";
import { ClientReport } from "./ClientReport.page";
import { CrmReport } from "./CrmReport.page";
import { DailyReport } from "./DailyReport.page";
import { EmployeeReport } from "./EmployeeReport.page";
import { ExpenseReport } from "./ExpenseReport.page";
import { MaterialReport } from "./MaterialReport.page";
import { ProjectReport } from "./ProjectReport.page";
import { Report } from "./Report.page";
import { SubcontractorReport } from "./SubcontractorReport.page";
import { ToolReport } from "./ToolReport.page";
import { UserReport } from "./UserReport.page";
import { VendorReport } from "./VendorReport.page";
import { WorkerReport } from "./WorkerReport.page";

/** Route tree for the report module, mounted under `/reports`. */
export const reportRoutes = (
  <Route path={REPORT_ROUTES.root}>
    <Route
      index
      element={
        <ProtectedRoute
          permissions={[
            GENERATE_DAILY_REPORT,
            GENERATE_CRM_REPORT,
            GENERATE_PROJECT_REPORT,
            GENERATE_WORKER_REPORT,
            GENERATE_VENDOR_REPORT,
            GENERATE_SUBCONTRACTOR_REPORT,
            GENERATE_CLIENT_REPORT,
            GENERATE_EMPLOYEE_REPORT,
            GENERATE_USER_REPORT,
            GENERATE_PURCHASE_REPORT,
            GENERATE_ACCOUNT_REPORT,
            GENERATE_TOOL_REPORT,
            GENERATE_MATERIAL_REPORT,
          ]}
          component={Report}
        />
      }
    />
    <Route path={REPORT_ROUTES.daily} element={<ProtectedRoute permissions={GENERATE_DAILY_REPORT} component={DailyReport} />} />
    <Route path={REPORT_ROUTES.crm} element={<ProtectedRoute permissions={GENERATE_CRM_REPORT} component={CrmReport} />} />
    <Route
      path={REPORT_ROUTES.project}
      element={<ProtectedRoute permissions={GENERATE_PROJECT_REPORT} component={ProjectReport} />}
    />
    <Route
      path={REPORT_ROUTES.worker}
      element={<ProtectedRoute permissions={GENERATE_WORKER_REPORT} component={WorkerReport} />}
    />
    <Route
      path={REPORT_ROUTES.vendor}
      element={<ProtectedRoute permissions={GENERATE_VENDOR_REPORT} component={VendorReport} />}
    />
    <Route
      path={REPORT_ROUTES.expense}
      element={<ProtectedRoute permissions={GENERATE_EXPENSE_REPORT} component={ExpenseReport} />}
    />
    <Route
      path={REPORT_ROUTES.subcontractor}
      element={<ProtectedRoute permissions={GENERATE_SUBCONTRACTOR_REPORT} component={SubcontractorReport} />}
    />
    <Route
      path={REPORT_ROUTES.client}
      element={<ProtectedRoute permissions={GENERATE_CLIENT_REPORT} component={ClientReport} />}
    />
    <Route
      path={REPORT_ROUTES.employee}
      element={<ProtectedRoute permissions={GENERATE_EMPLOYEE_REPORT} component={EmployeeReport} />}
    />
    <Route path={REPORT_ROUTES.user} element={<ProtectedRoute permissions={GENERATE_USER_REPORT} component={UserReport} />} />
    <Route
      path={REPORT_ROUTES.material}
      element={<ProtectedRoute permissions={GENERATE_MATERIAL_REPORT} component={MaterialReport} />}
    />
    <Route
      path={REPORT_ROUTES.account}
      element={<ProtectedRoute permissions={GENERATE_ACCOUNT_REPORT} component={AccountReport} />}
    />
    <Route path={REPORT_ROUTES.tool} element={<ProtectedRoute permissions={GENERATE_TOOL_REPORT} component={ToolReport} />} />
  </Route>
);
